export enum ESectionHeaderColors {
  DEFAULT = 'default',
  INHERIT = 'inherit',
  FUCHSIA = 'secondary-fuchsia',
}
